<template>
  <div id="InfoProgram">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">

      <div style="width:100%; padding:5px">
      <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeDialog(0)">{{$t('message.zamknij')}}</md-button>
      </div>
      <diV>
        <img src="../../assets/img/confi-dso.jpg" width="200"/>
        <p style="float:right; padding:10px; font-size:18px">{{$t('message.info_coop')}}<span style="font-family:calibri; font-size:24px; font-weight:bold"> BOSCH</span></p>
      </diV>
      <md-dialog-title>{{$t('message.o_programie')}} CONFI-DSO</md-dialog-title>
      <div id="content">
        <p v-html="$t('message.system_zasilania')"></p>
        <p v-html="$t('message.info_system_dso')"></p>
        <p v-html="$t('message.wersja_2_4')"></p>
        <p v-html="$t('message.wersja_2_3')"></p>
        <p v-html="$t('message.wersja_2_2')"></p>
      </div>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: 'InfoProgram',
  props: ['showDialog'],
  data () {
    return {

    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    }
  }
}
</script>

<style scoped>
div.md-dialog {
  background: rgba(0,0,0,0.6);
}
div.md-dialog div {
  background: rgb(255, 255, 255);
  width: 1024px;
  max-width: 1024px;
  padding: 30px;
}
#content {
  font-size: 16px;
  line-height: 24px;
  height: 480px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/InfoProgram.vue